import { createSelector } from 'reselect';

import { initialState } from './reducer';

const selectState = (state) => state.get('budgetAllocationFormPage') || initialState;

export const selectLoading = createSelector(selectState, (state) => state.get('loading'));
